export default class ComboOrderButton extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            totalPrice: (this.props.comboPrice).toFixed(2),
            count: this.props.quantity
           
        }
        this.increaseCounter = this.increaseCounter.bind(this);
        this.decreaseCounter = this.decreaseCounter.bind(this);
        this.calculateCurrentPrice = this.calculateCurrentPrice.bind(this);
      
        //ceate a glabal to retain current extras price
       
    }

    componentDidMount() {
        $(document).ready(function () {
            var buttonPosition = $("#pdp-footer-button-div").position();
            var comboStaticTextPosition = $(".combo-message.text-center").position();

            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                var comboStaticDisclaimerPosition = $('.ihop-listing-menu').height() + 250;
               // var disclaimerheightcheck = $('.disclaimerList').height() + $('.footer-sec').height();

                if ($(window).width() > 1080) {
                    if (scroll >= (comboStaticDisclaimerPosition - window.innerHeight)) {
                       $('#pdp-footer-button').css({ 'position': 'absolute', 'top': '100%', 'left': '25%' });
                      // $('#pdp-footer-button').css({ 'position': 'fixed', 'bottom': '0px', 'left': '25%', 'top': 'auto' });
                        $('#pdp-footer-button').parent().addClass('section-center');
                    }
                    else if (scroll == 0) {
                       // $('#pdp-footer-button').css({ 'position': 'relative', 'top': '100%', 'left': '25%' });
                        $('#pdp-footer-button').css({ 'position': 'fixed', 'bottom': '0px', 'left': '25%', 'top': 'auto' });
                        $('#pdp-footer-button').parent().addClass('section-center');
                    }
                    else {
                        $('#pdp-footer-button').css({ 'position': 'fixed', 'bottom': '0px', 'left': '25%', 'top': 'auto' });
                        $('#pdp-footer-button').parent().removeClass('section-center');
                    }
                }
                comboStaticDisclaimerPosition = $('.ihop-listing-menu').height() + 350;
                if ($(window).width() > 768 && $(window).width() < 1080) {
                    if (scroll >= (comboStaticDisclaimerPosition - window.innerHeight)) {
                        $('#pdp-footer-button').css({ 'position': 'absolute', 'top': '100%', 'left': '25%' });
                        // $('#pdp-footer-button').css({ 'position': 'fixed', 'bottom': '0px', 'left': '25%', 'top': 'auto' });
                        $('#pdp-footer-button').parent().addClass('section-center');
                    }
                    else if (scroll == 0) {
                        // $('#pdp-footer-button').css({ 'position': 'relative', 'top': '100%', 'left': '25%' });
                        $('#pdp-footer-button').css({ 'position': 'fixed', 'bottom': '142px', 'left': '25%', 'top': 'auto' });
                        $('#pdp-footer-button').parent().addClass('section-center');
                    }
                    else {
                        $('#pdp-footer-button').css({ 'position': 'fixed', 'bottom': '142px', 'left': '25%', 'top': 'auto' });
                        $('#pdp-footer-button').parent().removeClass('section-center');
                    }
                }

            });

            if ($(window).width() < 680) {
                console.log('inside if');
                var buttonPosition = $('#pdp-footer-button-div').position();
                $(window).scroll(function () {
                    var scroll = $(window).scrollTop();
                    console.log('inside scroll');
                    if (scroll >= (buttonPosition.top - 430)) {
                        $('#pdp-footer-button-div').addClass('fixedposition');
                    } else {
                        $('#pdp-footer-button-div').removeClass('fixedposition');
                    }
                });
            }
        });
     
    }
    
    calculateCurrentPrice(){
        this.setState({totalPrice: ((this.props.extrasPrice * this.state.count)  + parseFloat(this.state.totalPrice)).toFixed(2)})  
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (this.props.extrasPriceInEditMode!= nextProps.extrasPriceInEditMode) || (this.props.extrasPrice != nextProps.extrasPrice) || (this.state.count != nextState.count)
    }

    componentDidUpdate(){
            if(this.props.extrasPrice != 0){
                this.calculateCurrentPrice()
                this.props.sendUpdatedExtrasPrice(0)
        }
    }

      increaseCounter(e){
        e.preventDefault();
        this.setState((prevState, { count }) => ({   
          count: prevState.count + 1,
          totalPrice: ((this.state.totalPrice * (this.state.count + 1))/(this.state.count)).toFixed(2)
      }));
   
      
      };

     
      
      decreaseCounter(e){
        e.preventDefault();
       if(this.state.count > 1){
        this.setState((prevState, { count }) => ({
          count: prevState.count - 1,
          totalPrice: ((this.state.totalPrice/this.state.count) * (this.state.count - 1)).toFixed(2)
        }));
        }
   
      };
    

    render() {
    return (
        <div>
            <section className="section-center" id="pdp-footer-button-div">
                        <div className="pdp-footer-button" id="pdp-footer-button">
                            <div className="container">
                                <div className="row">                                    
                                    <div className="col-md-8 col-sm-12 col-xs-5">
                                        <div className="row">
                                            <div className="col-md-4 col-4">
                                                <div className="handle-counter">
                                                    <button className="counter-minus btn" aria-label="remove quantity" onClick={this.decreaseCounter}>-</button>
                                            <input type="text" className="quantityinput" onkeypress="return false;" id="item-count" readOnly={true} value={this.state.count} aria-label="item-count"/>
                                                    <button className="counter-plus btn" aria-label="add quantity" onClick={this.increaseCounter}>+</button>
                                                </div>
                                            </div>
                                            <div className="col-md-8 col-8">
                                                <div className="add-to-bag-button">
                                            {this.props.hasRequiredModifiers ?
                                                <button type="button" disabled tabIndex="-1" data-productId={this.props.productId} data-basketProductId={this.props.basketProductId} data-menuUrl={this.props.menuUrl} className="btn btn-danger btn-lg js-pdp-add-to-bag" aria-label={'Add $' + this.state.totalPrice + 'to Bag'} aria-atomic="true"><span className="js-totalprice" data-totalprice={this.state.totalPrice}>${this.state.totalPrice} </span>  | <span className="text" data-event={this.props.addToBagText}>{this.props.addToBagText}</span><span aria-live="polite" aria-atomic="true" className="sr-only">Selected Product Added to Cart</span> </button>
                                                :
                                                <button type="button" tabIndex="0" data-productId={this.props.productId} data-basketProductId={this.props.basketProductId} data-menuUrl={this.props.menuUrl} className="btn btn-danger btn-lg js-pdp-add-to-bag" aria-label={'Add $' + this.state.totalPrice + 'to Bag'} aria-atomic="true"><span className="js-totalprice" data-totalprice={this.state.totalPrice}>${this.state.totalPrice} </span>  | <span className="text" data-event={this.props.addToBagText}>{this.props.addToBagText}</span><span aria-live="polite" aria-atomic="true" className="sr-only">Selected Product Added to Cart</span> </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            </section>
    </div>
        );
    }
}
